module.exports = __webpack_public_path__ + "01ea978f/img/comment-question-icon.7dd26e04.svg";